import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AttributeInstancesDTO  {
    _originalTypeClassName = "zERP.BO.AttributeInstancesDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AttributeInstancesDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.AttributeId = null;
this.AttributeInstancesDTOKey = null;
this._key = this.AttributeInstancesDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Name:any;
AttributeId:any;
private _AttributeInstancesDTOKey:any;
get AttributeInstancesDTOKey(): any {
    return this._AttributeInstancesDTOKey;
  }
set AttributeInstancesDTOKey(value: any) {
    this._AttributeInstancesDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AttributeInstancesDTOKey == null || $this.AttributeInstancesDTOKey == 0;
            }


}